/* Dono fino Produktseite: Geschenkverpackung-Pill und Sticky-Warenkorb */
(() => {
  const details = () => document.querySelector('.product-details') || document;

  /* ---------- Geschenkverpackung ---------- */
  const GESCHENK = /geschenktasche|geschenkverpackung|geschenkbox/i;

  const findeGeschenkFeld = () => {
    const root = details();
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: (n) => (GESCHENK.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP),
    });
    let node;
    while ((node = walker.nextNode())) {
      const el = node.parentElement;
      if (!el || el.closest('.df-geschenk-pill, .df-produkttext, .faktenbox, .rte')) continue;
      if (el.offsetParent === null) continue; // ausgeblendet
      // möglichst das ganze Feld markieren, nicht nur die Überschrift
      return el.closest('[class*="tee-"][class*="field"], [class*="tee-"][class*="layer"], [class*="tee-"][class*="option"], fieldset') || el.parentElement || el;
    }
    return null;
  };

  const medienBox = () =>
    document.querySelector('.product-information__media') ||
    document.querySelector('media-gallery') ||
    document.querySelector('.tee-gallery-content')?.parentElement;

  let pill = null;
  const pillAktualisieren = () => {
    const feld = findeGeschenkFeld();
    const box = medienBox();
    if (!feld || !box) {
      if (pill) pill.hidden = true;
      return;
    }
    if (!pill) {
      pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'df-geschenk-pill';
      pill.innerHTML =
        '<svg class="df-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 10h16v10H4z"/><path d="M3 7h18v3H3z"/><path d="M12 7v13"/><path d="M12 7c-2-3-5-3-5-1s3 1 5 1c2 0 5 1 5-1s-3-2-5 1"/></svg><span class="df-geschenk-pill__text"><span>Geschenk&shy;verpackung</span><span>verfügbar</span></span>';
      pill.setAttribute('aria-label', 'Geschenkverpackung verfügbar, zur Auswahl springen');
      if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
      box.appendChild(pill);
      pill.addEventListener('click', () => {
        const ziel = findeGeschenkFeld();
        if (!ziel) return;
        ziel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        ziel.classList.remove('df-glow');
        void ziel.offsetWidth;
        ziel.classList.add('df-glow');
      });
    }
    pill.hidden = false;
  };

  /* ---------- Sticky Warenkorb (nur Handy) ---------- */
  const KANDIDATEN = [
    '.product-details .tee-btn--atc',
    '.product-details form[action*="/cart/add"] button[type="submit"]',
    '.product-details form[action*="/cart/add"] [name="add"]',
    '.product-details [class*="tee"][class*="add-to-cart"]',
    '.product-details [class*="tee"] button[type="submit"]',
  ];
  const findeWarenkorbButton = () => {
    for (const sel of KANDIDATEN) {
      const btn = [...document.querySelectorAll(sel)].find((b) => b.offsetParent !== null && !b.closest('.df-sticky-wk'));
      if (btn) return btn;
    }
    return null;
  };

  let beobachtet = null;
  const stickyEinrichten = () => {
    const bar = document.querySelector('.df-sticky-wk');
    if (!bar || window.innerWidth >= 750) return;
    const btn = findeWarenkorbButton();
    if (!btn || btn === beobachtet) return;
    beobachtet = btn;

    if (bar.parentElement !== document.body) document.body.appendChild(bar);
    bar.hidden = false;

    const io = new IntersectionObserver(
      ([e]) => {
        // Sichtbar, sobald der echte Button oben aus dem Bild gescrollt ist
        const darueber = e.boundingClientRect.top < 0;
        bar.classList.toggle('is-sichtbar', !e.isIntersecting && darueber);
      },
      { threshold: 0 }
    );
    io.observe(btn);

    bar.querySelector('.df-sticky-wk__btn').addEventListener('click', () => {
      const echt = findeWarenkorbButton();
      if (!echt) return;
      echt.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => echt.click(), 400);
    });
  };

  /* ---------- Steuerhinweis unter den Teeinblue-Preis ---------- */
  const steuerhinweisSetzen = () => {
    const hinweis = document.querySelector('.product-details .df-steuerhinweis');
    const zeile = document.querySelector('.product-details .tee-product-price');
    if (!hinweis || !zeile || zeile.nextElementSibling === hinweis) return;
    zeile.insertAdjacentElement('afterend', hinweis);
  };

  /* ---------- Preis nochmal unter dem Warenkorb-Button ---------- */
  let preisUnten = null;
  let preisQuelle = null;
  const preisUntenSpiegeln = () => {
    if (!preisUnten || !preisQuelle) return;
    if (preisQuelle.tagName === 'PRODUCT-PRICE') {
      // Shopify-Preisblock (Vorlage ohne Teeinblue-Warenkorb)
      const html = (preisQuelle.querySelector('[ref="priceContainer"]') || preisQuelle).innerHTML;
      const z = preisUnten.querySelector('.df-preis-unten__preise');
      if (z.innerHTML !== html) z.innerHTML = html;
      return;
    }
    const teile = [...preisQuelle.querySelectorAll('.tee-price-wrapper')]
      .filter((w) => w.textContent.trim() && !/spar/i.test(w.textContent))
      .sort((a, b) => (parseInt(a.style.order) || 0) - (parseInt(b.style.order) || 0))
      .map((w) => w.innerHTML)
      .join(' ');
    const ziel = preisUnten.querySelector('.df-preis-unten__preise');
    if (ziel.innerHTML !== teile) ziel.innerHTML = teile;
  };
  const preisUntenSetzen = () => {
    let quelle = document.querySelector('.product-details .tee-product-price');
    let aktionen = document.querySelector('.product-details .tee-form-actions');
    if (!quelle || !aktionen) {
      // Shopify-eigener Warenkorb-Button: Preis unter den Kaufbereich
      quelle = document.querySelector('.product-details product-price');
      const btn = [...document.querySelectorAll('.product-details form[action*="/cart/add"] [type="submit"], .product-details [name="add"]')].find(
        (b) => b.offsetParent !== null && !b.closest('.df-sticky-wk')
      );
      aktionen = btn && (btn.closest('[data-block-id]') || btn.closest('form'));
    }
    if (!quelle || !aktionen) return;
    if (!preisUnten) {
      preisUnten = document.createElement('div');
      preisUnten.className = 'df-preis-unten';
      preisUnten.innerHTML = '<div class="df-preis-unten__preise"></div><p class="df-preis-unten__hinweis">Inkl. MwSt., zzgl. Versandkosten</p>';
    }
    if (aktionen.nextElementSibling !== preisUnten) aktionen.insertAdjacentElement('afterend', preisUnten);
    if (quelle !== preisQuelle) {
      preisQuelle = quelle;
      new MutationObserver(preisUntenSpiegeln).observe(quelle, { childList: true, subtree: true, characterData: true });
    }
    preisUntenSpiegeln();
  };

  /* ---------- FAQ: Frage stellen über Judge.me ---------- */
  document.addEventListener('click', (ev) => {
    const link = ev.target.closest('.df-faq__kontakt[data-df-frage]');
    if (!link) return;
    const knopf = [...document.querySelectorAll('#judgeme_product_reviews .jm-action-buttons__button, #judgeme_product_reviews button')].find(
      (b) => /frage stellen/i.test(b.textContent)
    );
    if (!knopf) return; // ohne Fragen-Funktion bleibt es bei der E-Mail
    ev.preventDefault();
    knopf.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(() => knopf.click(), 450);
  });

  /* Teeinblue rendert nachträglich: auf Änderungen reagieren */
  let wartet = false;
  const pruefen = () => {
    if (wartet) return;
    wartet = true;
    setTimeout(() => {
      wartet = false;
      pillAktualisieren();
      stickyEinrichten();
      steuerhinweisSetzen();
      preisUntenSetzen();
    }, 120);
  };

  const start = () => {
    pruefen();
    // falls nach dem Laden nichts mehr nachgerendert wird (z. B. Desktop ohne Teeinblue-Warenkorb)
    window.addEventListener('load', pruefen);
    [800, 2500].forEach((ms) => setTimeout(pruefen, ms));
    new MutationObserver(pruefen).observe(details() === document ? document.body : details(), {
      childList: true,
      subtree: true,
      characterData: false,
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
